import axiosPost from "./axiosPost";

export const RNHHospitalDel = async (credentials, data) => {
    console.log(data)
    const body = {
        service: "RNHHospitalDel",
        params: {
            rnhHospitalId: data?.id,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
